(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-recommendations"] && !Shopify.designMode) return;
  try {
    class CartRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				const dataUrl = document.querySelector('cart-recommendations').getAttribute('data-url')

				fetch(dataUrl)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'cart-recommendations'
						);
						
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
							const slider = this.querySelector(".cart-products__swiper");
							if (!slider) {
								return "";
							}
							const sliderId = slider.dataset.id;

							const swiperParms = {
								keyboard: true,
								loop: false,
								slidesPerView: 1,
								scrollbar: {
									el: `#${sliderId} .swiper-scrollbar`,
									draggable: true,
								},
								navigation: {
									nextEl: `#${sliderId} .cart-swiper-button-next`,
									prevEl: `#${sliderId} .cart-swiper-button-prev`,
								},
							};
							const swiper = new Swiper(`#${sliderId} .swiper`, swiperParms);
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('cart-recommendations', CartRecommendations);
  } catch(e) { console.error(e); }
})();

})();
